/**
 * @Desription: 查询条件
 * @Author: netstar.sjj
 * @Date: 2022-01-05 15:05:00
 * @class NSQueryManager
 */
import { queryListFieldFunc } from './query-list-field';//list的field
//import { queryVoFieldFunc } from './query-vo-field';//vo的field
import { fieldSortFunc } from './field-sort';//排序
declare const window:any;
namespace NSQueryModelManager{
    /**
     *@description 初始化
     * @export init
     * @param {Array} fieldArray
     * @param {object} options
     * @param {string} options.id 来源容器id
     * @param {string/object} options.value 默认查询条件
     * @param {boolean} options.isUseSelectQuickSearch  是否使用快速查询
     * @param {string} options.source 字段来源 list/blockList/vo
     * @param {string} options.outputType  输出形式 list/blockList/
     * @param {number} quickQueryGroupNumber 快速查询条件输出个数
    */
    export function init(fieldArray:[],options:{ajaxData:{},sortField:string,id:string,source:string,outputType:string,isUseSelectQuickSearch:boolean,quickQueryGroupNumber:number,queryModeType?:string}){
        if(Array.isArray(fieldArray)){
            options.isUseSelectQuickSearch = typeof(options.isUseSelectQuickSearch)=='boolean' ? options.isUseSelectQuickSearch : true;//默认输出快速查询
            options.quickQueryGroupNumber = typeof(options.quickQueryGroupNumber)=='number' ? options.quickQueryGroupNumber : 1;//默认输出1个
            options.queryModeType = options.queryModeType ? options.queryModeType : (window.NetstarApiConfig.queryModeType ? window.NetstarApiConfig.queryModeType : 'select');//查询显示模式默认是select
            let resultQueryObject:any = {};//格式化存储数据
            switch(options.source){
                case 'vo':
                    //resultQueryObject = queryVoFieldFunc(fieldArray,options);
                    break;
                case 'list':
                case 'blockList':
                default:
                    resultQueryObject = queryListFieldFunc(fieldArray,options);
                    break;
            }
            console.log(resultQueryObject);
        }else{
            console.warn(fieldArray);
            console.table(options);
        }//fieldArray是数组才可以
    }
    export const setFieldSort = fieldSortFunc;
    export const getFieldByGrid = queryListFieldFunc;
}
export default NSQueryModelManager;